import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { APP_CONFIG, AUTH_SERVICE } from './app/app.config'
import {
  MsalService,
  MsalBroadcastService,
  MsalGuard,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MsalInterceptor,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular'
import {
  MSALInstanceFactory,
  MSALGuardConfigFactory,
  MSALInterceptorConfigFactory,
  MSALInitializedInstanceFactory,
} from './app/core/utils/msal-utils'
import {
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http'
import { AuthService } from './service/auth.service'
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser'
import { AppRoutingModule } from './app/app-routing.module'
import { FormsModule } from '@angular/forms'
import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components'
import { NgbToast } from '@ng-bootstrap/ng-bootstrap'
import { AppComponent } from './app/app.component'
import { importProvidersFrom } from '@angular/core'

fetch('/config.json')
  .then((response) => response.json())
  .then(async (config) => {
    const msalInstance = await MSALInitializedInstanceFactory(config)

    bootstrapApplication(AppComponent, {
      providers: [
        importProvidersFrom(
          BrowserModule,
          AppRoutingModule,
          FormsModule,
          RbUiComponentsModule,
        ),
        /* Changes start here. */
        provideHttpClient(withInterceptorsFromDi()),
        MsalService,
        MsalBroadcastService,
        MsalGuard,
        {
          provide: APP_CONFIG,
          useValue: config,
        },
        {
          provide: MSAL_INSTANCE,
          useValue: msalInstance,
          deps: [APP_CONFIG],
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true,
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory,
          deps: [APP_CONFIG],
        },
        {
          provide: AUTH_SERVICE,
          useClass: AuthService,
          multi: false,
        },
      ],
    }).catch((err) => console.error(err))
  })
